module.exports = __webpack_public_path__ + "img/loadImg.01f817e3.svg";